import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=7a02c8e3&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=7a02c8e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a02c8e3",
  null
  
)

export default component.exports